import React, { createContext } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import {
  ProfileScreen,
  AccountsScreen,
  CategoriesScreen,
  SettingsScreen,
  AddExchangeScreen,
  AddExpenseScreen,
  ExchangeScreen,
  ExpenseScreen,
  GetStartedScreen,
  LoginScreen,
  PrivacyScreen,
  TermsScreen,
} from "../pages";
import App from "../App";
import RequireAuth from "./RequireAuth";
import RequireSheet from './RequireSheet';

const RoutingContext = createContext({});

const RoutingProvider = ({ children }) => {
  const navigate = useNavigate();

  const routingState = {
    navigateBack: () => navigate(-1),
    navigateToRoot: () => navigate('/'),
    navigateToLogin: () => navigate('/login'),
    navigateToExpenses: () => navigate('/expenses'),
    navigateToExchanges: () => navigate('/exchanges'),
    navigateToProfile: () => navigate('/profile'),
    navigateToSettings: () => navigate('/profile/settings'),
    navigateToAccounts: () => navigate('/profile/accounts'),
    navigateToCategories: () => navigate('/profile/categories'),
  };

  return (
    <RoutingContext.Provider value={routingState}>
      {children}
    </RoutingContext.Provider>
  );
};

const RoutesProvider = ({GoogleSpreadsheet}) => {
  return (
    <BrowserRouter>
      <RoutingProvider>
        <Routes>
          <Route path="/" element={<App GoogleSpreadsheet={GoogleSpreadsheet} />}>
            <Route index element={<RequireSheet><ExpenseScreen /></RequireSheet>} />
            <Route path="expenses">
              <Route path=":row" element={<RequireSheet><AddExpenseScreen /></RequireSheet>} />
              <Route path="add" element={<RequireSheet><AddExpenseScreen /></RequireSheet>} />
              <Route index element={<RequireSheet><ExpenseScreen /></RequireSheet>} />
            </Route>
            <Route path="exchanges">
              <Route path=":row" element={<RequireSheet><AddExchangeScreen /></RequireSheet>} />
              <Route path="add" element={<RequireSheet><AddExchangeScreen /></RequireSheet>} />
              <Route index element={<RequireSheet><ExchangeScreen /></RequireSheet>} />
            </Route>
            <Route path="login" element={<LoginScreen />} />
            <Route path="profile" element={<RequireAuth><ProfileScreen /></RequireAuth>} />
            <Route path="profile/accounts" element={<RequireAuth><AccountsScreen /></RequireAuth>} />
            <Route path="profile/categories" element={<RequireAuth><CategoriesScreen /></RequireAuth>} />
            <Route path="profile/settings" element={<RequireAuth><SettingsScreen /></RequireAuth>} />
            <Route path="get-started" element={<RequireAuth><GetStartedScreen /></RequireAuth>} />
            <Route path="privacy" element={<PrivacyScreen />} />
            <Route path="terms" element={<TermsScreen />} />
          </Route>
        </Routes>
      </RoutingProvider>
    </BrowserRouter>
  );
};

export { RoutesProvider, RoutingContext };
